var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 54,
    height: 54,
    rx: 27,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.325,
    y: 1.325,
    width: 55.35,
    height: 55.35,
    rx: 27.675,
    stroke: "#FF2E2E",
    strokeOpacity: 0.21,
    strokeWidth: 1.35,
    style: {
      mixBlendMode: "plus-lighter"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1625 19.5768C22.7634 19.5764 22.3708 19.6777 22.0217 19.8711C21.6637 20.0536 21.3622 20.33 21.1493 20.6708C20.9365 21.0116 20.8204 21.4039 20.8135 21.8057V36.2196C20.8204 36.6214 20.9365 37.0136 21.1493 37.3544C21.3622 37.6952 21.6637 37.9717 22.0217 38.1542C22.3771 38.3516 22.7777 38.4534 23.1842 38.4496C23.5908 38.4458 23.9894 38.3366 24.341 38.1326L35.9915 30.9263C36.3511 30.7451 36.6532 30.4676 36.8643 30.1247C37.0753 29.7819 37.187 29.3871 37.1869 28.9845C37.1867 28.5819 37.0748 28.1873 36.8635 27.8446C36.6522 27.5019 36.3498 27.2246 35.9902 27.0437L24.3397 19.8914C23.9818 19.6848 23.5757 19.5763 23.1625 19.5768Z",
    fill: "#9E120E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play_button.71d38150e0ffac3df8f30a4f9e563c2b.svg";
export { ForwardRef as ReactComponent };